import { useEffect, useState } from 'react';
import { api, ApiError } from '../api';

export default function AccountLifecycle() {
  const reset = window.location.pathname === '/reset-password';
  const verify = window.location.pathname === '/verify-email';
  const token = new URLSearchParams(window.location.search).get('token') ?? '';
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(verify);
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!verify) return;
    if (!token) {
      setError('This verification link is incomplete. Request a new one from your account.');
      setBusy(false);
      return;
    }
    api.confirmVerification(token)
      .then(() => setMessage('Your email is verified. You can sign in now.'))
      .catch((err) => setError(err instanceof ApiError ? err.message : 'Verification failed.'))
      .finally(() => setBusy(false));
  }, [token, verify]);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      if (reset) {
        if (!token) throw new Error('This reset link is incomplete.');
        await api.resetPassword(token, password);
        setMessage('Password changed. All previous sessions were signed out.');
      } else {
        await api.forgotPassword(email);
        setMessage('If that address has a ScaleAds AI account, a reset link is on its way.');
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Could not complete the request.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth-shell">
      <div className="auth-card">
        <div className="auth-brand">ScaleAds AI<small>OS 3.0</small></div>
        <h1>{verify ? 'Verify your email' : reset ? 'Choose a new password' : 'Reset your password'}</h1>
        {busy && <p className="auth-sub">Working…</p>}
        {message && <p className="auth-sub">{message}</p>}
        {error && <p className="auth-error">{error}</p>}
        {!verify && !message && (
          <form onSubmit={submit}>
            {reset ? (
              <label className="field"><span>New password</span><input className="input" type="password" autoComplete="new-password" value={password} onChange={(e) => setPassword(e.target.value)} required /><em className="hint">Use at least 12 characters.</em></label>
            ) : (
              <label className="field"><span>Email</span><input className="input" type="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus /></label>
            )}
            <button className="btn brand auth-submit" type="submit" disabled={busy}>{busy ? 'Working…' : reset ? 'Change password' : 'Send reset link'}</button>
          </form>
        )}
        <p className="auth-switch"><a href="/">Back to sign in</a></p>
      </div>
    </div>
  );
}
